import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-profile-image-dialog',
  templateUrl: './profile-image-dialog.component.html'
})
export class ProfileImageDialogComponent {

  // Preview shown inside the dialog (data URL). Starts with the current image.
  previewImage: string = '';
  // Base64 (without the data: prefix) of the newly selected file, ready for the server.
  selectedBase64: string = '';
  selectedFileName: string = '';

  constructor(
    public dialogRef: MatDialogRef<ProfileImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {
    this.previewImage = data && data.currentImage ? data.currentImage : '';
  }

  // Same validation rules the profile page uses: only .jpg/.jpeg, max 500 kb.
  onFileSelected(files: any) {
    if (!files || files.length === 0) {
      return;
    }
    let file = files[0];
    let validFiles = ['.jpg', '.jpeg'];
    let isValid = false;
    for (let j = 0; j < validFiles.length; j++) {
      let ext = validFiles[j];
      if (file.name.substr(file.name.length - ext.length, ext.length).toLowerCase() == ext.toLowerCase()) {
        isValid = true;
        break;
      }
    }

    if (!isValid) {
      this.toastr.error(
        this.translateService.instant('Sorry, ') + file.name +
        this.translateService.instant(' is invalid, allowed extensions are: ') + validFiles.join(', '),
        this.translateService.instant('error'));
      return;
    }

    // 500 kb limit (500 * 1024 bytes)
    if (file.size > 500 * 1024) {
      this.toastr.error(
        this.translateService.instant('file size should not be greater then 500 kb.'),
        this.translateService.instant('error'));
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let result = reader.result.toString();
      this.previewImage = result;
      this.selectedBase64 = result.split(',')[1];
      this.selectedFileName = file.name;
    };
  }

  Cancel() {
    this.dialogRef.close();
  }

  Upload() {
    if (!this.selectedBase64) {
      this.toastr.error(
        this.translateService.instant('Please select an image first.'),
        this.translateService.instant('error'));
      return;
    }
    // Hand the selected image back to the layout component to save on the server.
    this.dialogRef.close({
      image: this.selectedBase64,
      imageName: this.selectedFileName,
      previewImage: this.previewImage
    });
  }
}
